// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1_toM","content":"RecentSearches_content__3LgA_"};